import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/care-enrolments/details/index.js